import { CheckCircle } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import classes from '../styles.module.scss'

type Props = {
  title: string
  text: string
  dataTest?: string
}

export default function SuccessfullyVerified({ title, text, dataTest }: Props) {
  return (
    <div className={classes.root}>
      <h4 className={classes.title}>{title}</h4>
      <p data-test={dataTest} className={cx('text-smaller', classes.textVerified)}>
        <CheckCircle className={classes.verifiedIcon} /> {text}
      </p>
    </div>
  )
}
